export default __webpack_public_path__ + "./images/mq.05c7140d.png";